import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
import { Duration, User } from "./deletePJPTypes";
import { MONTHS } from "./deletePJPUtils";
const getLoggedInUserID = () => {
    const authContext = JSON.parse(localStorage.getItem('authContext') || '{}');
    if (!authContext || !authContext.user || !authContext.user.loginId) {
        return "";
    }
    return authContext.user.loginId;
}
export const getMonths = () : string[] => {
    return MONTHS;
}
const getFormatedDates = (duration: Duration) => {
    const year = Number(duration.year);
    const monthIndex = new Date(Date.parse(`${duration.month} 1, ${year}`)).getMonth();
    const month = String(monthIndex + 1).padStart(2, "0");
  
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    // Helper to format date as YYYY-MM-DD%20HH:mm:ss
    const formatDate = (date: Date, isEnd = false) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const time = isEnd ? "23:59:59" : "00:00:00";
      return `${y}-${m}-${d}%20${time}`;
    };
  
    // Case 1: current month
    if (monthIndex === today.getMonth() && year === today.getFullYear()) {
      const monthEndDate = new Date(year, monthIndex + 1, 0); // last day of month
      return {
        startDate: formatDate(today, false),
        endDate: formatDate(monthEndDate, true),
      };
    }
  
    // Case 2: other months
    const startDate = `${year}-${month}-01%2000:00:00`;
    const lastDate = new Date(year, monthIndex + 1, 0).getDate();
    const endDate = `${year}-${month}-${String(lastDate).padStart(2, "0")}%2023:59:59`;
  
    return {
      startDate,
      endDate,
    };
  };
  
  
export const fetchUsers = async (duration: Duration) => {
    try {
        const { startDate, endDate } = getFormatedDates(duration);
        const approvedby = getLoggedInUserID()
        const api = `/v1/query/uniquePJPUserNameDelete?startDate=${startDate}&endDate=${endDate}&approvedby=${approvedby}`;
        const response = await ChannelkartNetworkGet(api);
        if(response.status === 200)
            return response.data.features;
        else 
            return [];
    } catch (error) {
        throw new Error(`Failed to fetch users`);
    }
}
export const fetchUserPJPData = async (user :User , duration: Duration) => {
    try {
        const { startDate, endDate } = getFormatedDates(duration);
        const approvedby = getLoggedInUserID()
        const loginId = user.loginid;
        const api = `/v1/query/DeletePendingPJP?startDate=${startDate}&endDate=${endDate}&loginid=${loginId}&approvedby=${approvedby}`;
        const response = await ChannelkartNetworkGet(api);
        if(response.status === 200)
            return response.data.features;
        else 
            return [];

    } catch (error) {
        throw new Error(`Failed to fetch user PJP data`);
    }
}
export const rejectPjp = async (pjpData : any, message : string) => {
    if (!pjpData || pjpData.length === 0) {
        throw new Error("PJP data is required.");
    }

    if (!message || message.trim() === "") {
        throw new Error("Message is required.");
    }

    try {
        const approvedBy = getLoggedInUserID();
        // only include the pjpData this is more than >= today's date ( pjpDate )
        const today = new Date();
        // Strip time
        today.setHours(0, 0, 0, 0);
        
        // Get end of the current month
        const monthEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        monthEndDate.setHours(23, 59, 59, 999); // set to end of day
        
        const rejectedFeatures = pjpData
          .map((pjp: any) => {
            return {
              loginId: pjp?.userName,
              pjpDate: pjp?.pjp_date,
              referenceNumber: `${pjp?.userName}:${pjp?.pjp_date?.split(" ")[0]}`,
              pjpPlan: pjp?.PJPPlan,
              beat: pjp?.beat,
              approvedBy: approvedBy,
              statusRemarks: message,
              status: "Rejected",
            };
          })
          .filter((pjp: any) => {
            // Extract just the date part
            const dateStr = pjp?.pjpDate?.split(" ")[0];
            const pjpDate = new Date(dateStr);
        
            return pjpDate >= today && pjpDate <= monthEndDate;
          });
        const response = await ChannelkartNetworkPut("/v1/deliveryPJP/batch", {
            features: rejectedFeatures
        });

        if (response?.status >= 200 && response?.status < 300) {
            return response.data;
        } else {
            throw new Error("Failed to reject PJP");
        }
    } catch (error) {
        console.error(error);
        throw new Error("Failed to reject PJP: ");
    }
};
